/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
export { MockAnimationDriver, MockAnimationPlayer } from './mock_animation_driver';
//# sourceMappingURL=testing.js.map